import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from './types';

// Pre-typed Redux hooks. Typed code reads the store through these, so a
// selector sees the real state shape and a dispatched thunk needs no cast.
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
